// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ec-a";
export var fulfillmentFormRail = "_ec-9";
export var headerTitleRow = "_ec-c";
export var orderDetailsWrapper = "_ec-7";
export var orderLinkTrigger = "_ec-2";
export var paymentInformationGrid = "_ec-h";
export var paymentSummaryColumn = "_ec-i";
export var shipmentContainer = "_ec-b";
export var shipmentDetailsMainPane = "_ec-8";
export var shipmentNavigationCard = "_ec-5";
export var shipmentNavigationRail = "_ec-3";
export var shipmentNavigationRailHeader = "_ec-4";
export var shipmentSummaryFact = "_ec-e";
export var shipmentSummaryGrid = "_ec-d";
export var shipmentSummaryMetadataRow = "_ec-f";
export var shipmentSummaryTags = "_ec-g";
export var shipmentWorkspace = "_ec-0";
export var shipmentWorkspaceContent = "_ec-6";
export var shipmentWorkspaceHeader = "_ec-1";